/**
 * Bundle Tiers - Add-to-cart handler for creator combo bundles
 * Handles tier selection, cart batching, and bundle property tagging
 */
(function () {
  'use strict';
  if (window.__d1BundleTiersScriptLoaded) return;
  window.__d1BundleTiersScriptLoaded = true;

  function setProductFormBusy(productForm, busy) {
    if (!productForm) return;
    productForm.d1AddingToCart = !!busy;
    var submit = productForm.querySelector('[type="submit"]');
    if (submit) {
      submit.toggleAttribute('disabled', !!busy);
      submit.setAttribute('aria-busy', busy ? 'true' : 'false');
      submit.classList.toggle('loading', !!busy);
      var spinner = submit.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    }

    // Mirror loading on sticky ATC if present
    var sticky = document.querySelector('[data-d1-sticky-submit]');
    if (sticky) {
      sticky.toggleAttribute('disabled', !!busy);
      sticky.classList.toggle('loading', !!busy);
      sticky.setAttribute('aria-busy', busy ? 'true' : 'false');
      var stickySpinner = sticky.querySelector('.loading-overlay__spinner, .loading__spinner');
      if (stickySpinner) {
        stickySpinner.style.display = busy ? 'flex' : 'none';
        stickySpinner.classList.toggle('hidden', !busy);
      }
    }
  }

  // advertised − main web so promo mains still cart to package price.
  // Stale-high advertised (main on sale, package not republished) keeps live addon.
  function effectiveAccessoryTargetCents(advertisedCents, mainWebCents, fallbackBundleCents) {
    var advertised = parseInt(advertisedCents, 10) || 0;
    var web = parseInt(mainWebCents, 10) || 0;
    var fallback = parseInt(fallbackBundleCents, 10) || 0;
    var live = web + fallback;
    if (advertised > 0 && advertised < live) return Math.max(0, advertised - web);
    return Math.max(0, fallback);
  }

  function readMainWebCents(formEl) {
    if (typeof window.__d1CurrentVariantPriceCents === 'number' && window.__d1CurrentVariantPriceCents > 0) {
      return window.__d1CurrentVariantPriceCents;
    }
    if (!formEl) return 0;
    var idInput = formEl.querySelector('[name=id]');
    var variantId = idInput ? String(idInput.value || '') : '';
    if (!variantId || !window.__d1VariantPrices) return 0;
    var n = parseInt(window.__d1VariantPrices[variantId], 10);
    return Number.isFinite(n) ? n : 0;
  }

  // One line per variant. Duplicate IDs (same instance) used to merge in
  // Shopify as qty 2 and still get the extras price — D1S3497.
  function collapseAccessoryLines(ids, qtys) {
    var seen = {};
    var out = [];
    (ids || []).forEach(function (rawId, index) {
      var id = parseInt(rawId, 10);
      if (!(id > 0) || seen[id]) return;
      seen[id] = true;
      var q = qtys && qtys[index] != null ? parseInt(qtys[index], 10) : 1;
      out.push({ id: id, quantity: q > 0 ? q : 1 });
    });
    return out;
  }

  function getSelectedBundleTier(formEl) {
    var root = document.querySelector('[data-d1-bundle-tiers]');
    if (!root) return null;
    var input = root.querySelector('[data-d1-bundle-tier-input]:checked');
    if (!input || input.disabled) return null;
    var wrap = input.closest('[data-d1-tier-wrapper]');
    if (
      !wrap ||
      wrap.style.display === 'none' ||
      wrap.classList.contains('is-unavailable') ||
      wrap.getAttribute('data-tier-unavailable') === 'true'
    ) {
      return null;
    }
    var ids = (wrap.getAttribute('data-accessory-ids') || '')
      .split(',')
      .map(function (s) { return parseInt(s.trim(), 10); })
      .filter(function (n) { return n > 0; });
    var qtys = (wrap.getAttribute('data-accessory-qtys') || '')
      .split(',')
      .map(function (s) { return parseInt(s.trim(), 10); });
    // Keep index-aligned with accessoryIds; default missing/invalid to 1.
    var accessoryQuantities = ids.map(function (_id, index) {
      var q = qtys[index];
      return q > 0 ? q : 1;
    });
    var collapsed = collapseAccessoryLines(ids, accessoryQuantities);
    ids = collapsed.map(function (line) { return line.id; });
    accessoryQuantities = collapsed.map(function (line) { return line.quantity; });
    var fallback = parseInt(wrap.getAttribute('data-bundle-price-cents') || '0', 10) || 0;
    var advertised = parseInt(wrap.getAttribute('data-advertised-price-cents') || '0', 10) || 0;
    return {
      tierId: input.value,
      tierName: wrap.getAttribute('data-tier-title') || input.value,
      bundlePriceCents: effectiveAccessoryTargetCents(advertised, readMainWebCents(formEl), fallback),
      accessoryIds: ids,
      accessoryQuantities: accessoryQuantities,
      parentId: root.getAttribute('data-d1-parent-product-id') || '',
    };
  }

  function hasBundleAccessoryAdd() {
    var b = getSelectedBundleTier();
    return b && b.tierId && b.tierId !== 'none' && b.accessoryIds.length > 0;
  }

  function visibleBundleRoot() {
    var section = document.querySelector('[data-d1-bundle-tiers]');
    if (!section || section.hidden || section.getAttribute('aria-hidden') === 'true') return null;
    return section;
  }

  function requireBundleChoice() {
    var section = visibleBundleRoot();
    if (!section) return true;
    var input = section.querySelector('[data-d1-bundle-tier-input]:checked');
    var wrap = input && input.closest('[data-d1-tier-wrapper]');
    var valid = !!(
      input &&
      !input.disabled &&
      wrap &&
      wrap.style.display !== 'none' &&
      wrap.getAttribute('data-tier-unavailable') !== 'true' &&
      wrap.getAttribute('data-listing-hidden') !== 'true'
    );
    if (valid) return true;
    section.classList.add('is-needs-choice', 'is-awaiting-selection');
    section.classList.remove('has-selection');
    try {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {}
    return false;
  }

  function getCartAndSections() {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = (cart && cart.getSectionsToRender)
      ? cart.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    return { cart: cart, sections: sections };
  }

  function postCartItems(items, ref) {
    var payload = { items: items };
    if (ref.sections.length) {
      payload.sections = ref.sections;
      payload.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) {
        // Shopify returns 422 with { status, description, message } for bad variant IDs.
        if (!r.ok || body.status) {
          var msg =
            body.description ||
            body.message ||
            (typeof body.errors === 'string' ? body.errors : null) ||
            'Could not add selected bundle to cart.';
          var err = new Error(msg);
          err.response = body;
          err.items = items;
          throw err;
        }
        return body;
      });
    });
  }

  function renderCartSuccess(response, ref, silent) {
    if (!response) return;
    if (silent) {
      // Bundle is in the cart; Care modal is still open — don't publish a
      // cartUpdate (that can refresh/open the drawer over the modal).
      return;
    }
    if (ref.cart) {
      if (ref.cart.classList.contains('is-empty')) ref.cart.classList.remove('is-empty');
      ref.cart.renderContents(response);
    } else {
      window.location = window.routes.cart_url;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bundle-tiers',
        cartData: response,
      });
    }
  }

  function batchAdd(items, callback, options) {
    var silent = options && options.silent;
    var ref = getCartAndSections();
    return postCartItems(items, ref)
      .then(function (response) {
        renderCartSuccess(response, ref, silent);
        if (callback) callback(null, response);
        return response;
      })
      .catch(function (err) {
        var msg =
          'This bundle could not be added because one or more included items are unavailable. No items were added.';
        if (typeof window.d1ShowToast === 'function') window.d1ShowToast(msg);
        console.error('Atomic bundle add failed:', err, {
          hint: 'Check custom.bundle_tiers accessories are live-store variant IDs with available inventory.',
          items: err && err.items,
        });
        if (callback) callback(err);
        throw err;
      });
  }

  function openCartWithResponse(response) {
    var ref = getCartAndSections();
    renderCartSuccess(response, ref, false);
  }

  function newBundleInstanceId() {
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function buildPayload(formEl) {
    var mainVariantId = parseInt(formEl.querySelector('[name=id]').value, 10);
    var quantityInput = formEl.querySelector('[name=quantity]');
    var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    var bundle = getSelectedBundleTier(formEl);
    var hasBundle =
      bundle && bundle.tierId && bundle.tierId !== 'none' && bundle.accessoryIds.length > 0;

    // Tag the main line so Shopify won't merge "No Extras" into a bundled line
    // (same variant + empty properties previously collapsed them).
    if (hasBundle) {
      var parentId = String(bundle.parentId || '');
      var instanceId = newBundleInstanceId();
      var mainProperties = {
        _d1_bundle_instance: instanceId,
        _d1_bundle_selection: bundle.tierId,
      };
      if (bundle.tierName) mainProperties.Bundle = String(bundle.tierName);
      if (window.D1AccessoryAtc && window.D1AccessoryAtc.stampPreorderProps) {
        var submit = formEl.querySelector('[data-d1-main-submit], [name="add"]');
        window.D1AccessoryAtc.stampPreorderProps(
          mainProperties,
          window.D1AccessoryAtc.isPreorderControl(submit),
        );
      }

      var items = [{ id: mainVariantId, quantity: qty, properties: mainProperties }];
      collapseAccessoryLines(bundle.accessoryIds, bundle.accessoryQuantities).forEach(function (line) {
        var perPackage = line.quantity;
        var accQty = Math.max(1, perPackage) * qty;
        items.push({
          id: line.id,
          quantity: accQty,
          properties: Object.assign(
            {
              _d1_accessory_upsell: 'true',
              _d1_bundle_tier: bundle.tierId,
              _d1_bundle_parent: parentId,
              _d1_bundle_instance: instanceId,
              _d1_bundle_name: bundle.tierName,
              _d1_bundle_price_cents: String(bundle.bundlePriceCents),
            },
            bundle.tierName ? { Bundle: String(bundle.tierName) } : {}
          ),
        });
      });
      return items;
    }

    var noneProps = { _d1_bundle_selection: 'none' };
    if (window.D1AccessoryAtc && window.D1AccessoryAtc.stampPreorderProps) {
      var noneSubmit = formEl.querySelector('[data-d1-main-submit], [name="add"]');
      window.D1AccessoryAtc.stampPreorderProps(
        noneProps,
        window.D1AccessoryAtc.isPreorderControl(noneSubmit),
      );
    }
    return [
      {
        id: mainVariantId,
        quantity: qty,
        properties: noneProps,
      },
    ];
  }

  // Expose API for potential external use
  window.d1BundleTiers = {
    awaitingAtcLabel: 'Select your bundle',
    getSelectedTier: getSelectedBundleTier,
    hasBundleAdd: hasBundleAccessoryAdd,
    requireChoice: requireBundleChoice,
    collapseAccessoryLines: collapseAccessoryLines,
    buildPayload: buildPayload,
    batchAdd: batchAdd,
    openCartWithResponse: openCartWithResponse,
    setBusy: setProductFormBusy
  };

  function careRefreshEnabled() {
    return !!(window.d1CareRefresh && window.d1CareRefresh.enabled && document.getElementById('CareRefreshModal'));
  }

  // Auto-bind to product forms
  function bindProductForms() {
    var productForms = document.querySelectorAll('product-form');
    productForms.forEach(function (pf) {
      if (pf.d1BundleTiersBound) return;
      var form = pf.querySelector('form');
      if (!form) return;
      pf.d1BundleTiersBound = true;

      form.addEventListener('submit', function (e) {
        if (pf.d1AddingToCart) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }

        if (!requireBundleChoice()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }

        if (!hasBundleAccessoryAdd()) return; // Let care-refresh.js or default handler take over

        e.preventDefault();
        e.stopImmediatePropagation();

        // Care Refresh owns the UX when enabled (modal + background bundle add).
        if (careRefreshEnabled() && typeof window.d1CareRefresh.openForBundle === 'function') {
          window.d1CareRefresh.openForBundle(pf, form);
          return;
        }

        var items = buildPayload(form);
        if (items.length < 2) {
          console.warn('Bundle selected but no accessory variant IDs found on the tier card.');
          return;
        }
        setProductFormBusy(pf, true);
        batchAdd(items).finally(function () {
          setProductFormBusy(pf, false);
        }).catch(function () {});
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindProductForms);
  } else {
    bindProductForms();
  }
  document.addEventListener('product-info:loaded', bindProductForms);
})();
